module.exports = __webpack_public_path__ + "img/1523233133.805fd24b.jpg";